import { Track } from "GlobalUtils/Track";
import React, { useState, useEffect, memo, useCallback } from "react";
import UsedCarsSearchWidget from "./UsedCarsSearchWidget";
import NewCarsSearchWidget from "./NewCarsSearchWidget";
import BannerDropDown from "./BannerDropDown";
import Cookies from "js-cookie";
import { CSSFlex } from "GlobalComponent/CSSCore";
import getThemeClasses from "@oxygen/theme";
import styles from "./scss/CarSearchWidget.module.scss";
import { platform as PLATFORM } from "GlobalEnum/Platform";
import { NewCarSearchSuggestions } from "./NewCarSearchSuggestions";
import { SEARCH_TYPES } from "../../constants";

const SEARCH_TYPE_COOKIE = "_carSearchType";
const heading = "FIND THE RIGHT CAR";
const containerClasses = getThemeClasses(`
  width-full;
  pt-5 md:pt-0;
  pb-5;
  pl-4 md:pl-0;
  pr-4 md:pr-0;
  ml-auto;
  mr-auto;
`);
const headingClasses = getThemeClasses(`
  font-size-10 md:font-size-13;
  text-align-center;
  color-white;
  text-transform-uppercase;
`);
const searchContainerClasses = getThemeClasses(`
  width-full;
  mt-4;
`);
const dropDownContainerClasses = getThemeClasses(`
  width-full;
  bg-white;
  border-radius-3;
  align-items-center;
  height-11;
`);

const setSearchTypeInCookies = (type = SEARCH_TYPES.NEW_CARS) => {
  console.log("Search Type cookie set", type);
  const cookieDomain = window.location.hostname.replace("www.", "");
  Cookies.set(SEARCH_TYPE_COOKIE, type, { expires: 30, domain: cookieDomain });
};

const handleNcfLinkClick = event => {
  window.location.href = "/find-car/";
};

const Heading = ({ isMobile }) =>
  isMobile ? (
    <Track
      as="h1"
      onClick={handleNcfLinkClick}
      className={headingClasses}
      trackClick
      gaCat="NCFLinkage"
      gaActClick="NCFLinkage_click"
      gaLblClick="Find the right car"
      data-testing-id="ncf-banner-link"
    >
      {heading}
    </Track>
  ) : (
    <h1 className={headingClasses}>{heading}</h1>
  );

export const CarSearchWidget = memo(function CarSearchWidget({
  openGlobalSearch,
  newCarPlaceHolder,
  searchExample,
  globalLocation,
  widgetSearchType = SEARCH_TYPES.NEW_CARS,
  platform,
  containerClassName = "",
}) {
  const [searchType, setSearchType] = useState(widgetSearchType);

  useEffect(() => {
    if (searchType === SEARCH_TYPES.NONE) {
      setSearchTypeInCookies();
    }
  }, [searchType]);

  const handleSearchTypeSelection = useCallback((event, activeIndex) => {
    if (activeIndex === 0) {
      setSearchType(SEARCH_TYPES.NEW_CARS);
      setSearchTypeInCookies(SEARCH_TYPES.NEW_CARS);
    } else {
      setSearchType(SEARCH_TYPES.USED_CARS);
      setSearchTypeInCookies(SEARCH_TYPES.USED_CARS);
    }
  }, []);

  const isNewCarSearchType = searchType !== SEARCH_TYPES.USED_CARS;
  const isMobile = platform.id === PLATFORM.MOBILE.id;
  return (
    <div
      className={`${containerClasses} ${containerClassName} ${styles.searchContainer}`}
    >
      <Heading isMobile={isMobile} />
      <div className={searchContainerClasses}>
        <CSSFlex className={dropDownContainerClasses}>
          <BannerDropDown
            visible={searchType === SEARCH_TYPES.NONE}
            activeIndex={isNewCarSearchType ? 0 : 1}
            onSelect={handleSearchTypeSelection}
          >
            <span>{"New"}</span>
            <span>{"Used"}</span>
          </BannerDropDown>
          {isNewCarSearchType ? (
            <NewCarsSearchWidget
              openGlobalSearch={openGlobalSearch}
              newCarPlaceHolder={newCarPlaceHolder}
              platform={platform}
            />
          ) : (
            <UsedCarsSearchWidget
              globalLocation={globalLocation}
              platform={platform}
            />
          )}
        </CSSFlex>
      </div>
      {isNewCarSearchType && (
        <NewCarSearchSuggestions
          searchExample={searchExample}
          platform={platform}
        />
      )}
    </div>
  );
});

CarSearchWidget.displayName = "CarSearchWidget";
